import { render, staticRenderFns } from "./ExchangeBindPopup.vue?vue&type=template&id=29efb236&scoped=true"
import script from "./ExchangeBindPopup.vue?vue&type=script&lang=ts"
export * from "./ExchangeBindPopup.vue?vue&type=script&lang=ts"
import style0 from "./ExchangeBindPopup.vue?vue&type=style&index=0&id=29efb236&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29efb236",
  null
  
)

export default component.exports